(function () {
  'use strict';

  angular.module('app').component('priceListPage', PriceListPageComponent());

  function PriceListPageComponent() {
    return {
      templateUrl: './app/ajs/price-lists/price-list-page.component.html',
      controller: PriceListDetailCtrl,
      controllerAs: 'vm',
      bindings: {},
    };
  }

  PriceListDetailCtrl.$inject = ['$location', '$routeParams', 'AbilityService', 'PriceListService'];

  function PriceListDetailCtrl($location, $routeParams, AbilityService, PriceListService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.permissions = {
      canCreate: AbilityService.can('create_pricelist_accountadmin'),
    };

    // private properties
    // -----------------------
    let itemId = $routeParams.id;

    // Initializers
    getItem();

    // public methods
    // -----------------------
    vm.onSavedItem = function (item) {
      $location.path(`/price_lists/${item.id}`);
    };

    vm.onCanceledItem = function () {
      $location.path('/price_lists');
    };

    // private methods
    // -----------------------
    function getItem() {
      if (itemId) {
        //edit
        PriceListService.getPriceList(itemId).then(function (data) {
          vm.item = data;
        });
      } else {
        vm.item = {};
      }
    }
  }
})();
